import { Loader, ThemeProvider } from '@pw-tech/omni-ui';
import { FlagProvider } from '@unleash/proxy-client-react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import QueryClientWrapper from './lib/QueryClientWrapper';
import { ReduxProviders } from './lib/redux/providers';
import useAppConfig, { updateWebSdkConfig, useAppThemeInjection } from './lib/useAppConfig';
import { isOTT } from './lib/utilities';
import PwWebSDKInstance from './services/pwWebSDKService';
import { UnleashConfig } from './services/unleashService';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const unleashConfig = UnleashConfig.getInstance().config;
const isDarkThemeEnabled = isOTT();

// if (['prod'].includes(process.env.REACT_APP_ENVIRONMENT || '')) {
//   console.log = console.error = console.debug = () => {};
// }

console.log('<><> debug', process.env.REACT_APP_ENVIRONMENT);

const ThemeWrapper: React.FC = () => {
  const { appTheme, appConfig } = useAppConfig();
  useAppThemeInjection(appConfig);
  const [isAppInitialized, setIsAppInitialized] = useState(false);

  useEffect(() => {
    const init = async () => {
      if (!PwWebSDKInstance) {
        setIsAppInitialized(true);
        return;
      }

      if (appConfig?.orgConfig) {
        await updateWebSdkConfig(appConfig, PwWebSDKInstance);
      }

      setIsAppInitialized(true);
    };

    init();
  }, [appConfig, PwWebSDKInstance]);

  return (
    <ThemeProvider theme={appTheme || {}} colorScheme={isDarkThemeEnabled ? 'dark' : undefined}>
      {!isAppInitialized ? (
        <Loader color='static-black' />
      ) : (
        <>
          <div className='!z-[99999]' id='pw_auth-flow' />
          <QueryClientWrapper>
            <ReduxProviders>
              <FlagProvider config={unleashConfig}>
                <App />
              </FlagProvider>
            </ReduxProviders>
          </QueryClientWrapper>
        </>
      )}
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<ThemeWrapper />);

serviceWorkerRegistration.register();
